import ProviderLogo from './ProviderLogo';

export default ProviderLogo;
